"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialMenu = exports.MaterialMenuUnstyled = void 0;
const material_ui_1 = require("material-ui");
const Menu_1 = require("material-ui/Menu");
const react_1 = require("react");
const React = require("react");
const decorate = material_ui_1.withStyles(theme => ({
    paper: {
        marginTop: "40px"
    }
}));
class MaterialMenuUnstyled extends react_1.Component {
    render() {
        const { anchorEl, children, classes, onClose, open } = this.props;
        return (React.createElement(Menu_1.default, { anchorEl: anchorEl, classes: classes, open: open, onClose: onClose }, children));
    }
}
exports.MaterialMenuUnstyled = MaterialMenuUnstyled;
exports.MaterialMenu = decorate(MaterialMenuUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/menu/menu.tsx
// module id = 3157
// module chunks = 0